/* eslint-disable @typescript-eslint/no-explicit-any */
import Icon from "@ant-design/icons";
import { Avatar, Col, Dropdown, notification, Row } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Styles from "./layout.module.scss";
import AirbusLogo from "../../assets/images/SVG/airbusLogo.svg";
import FlowWise from "../../assets/images/SVG/flowWise.svg";
import Cookies from "universal-cookie";
import { logOut } from "./mutations";
import { useMutation } from "@tanstack/react-query";
import { CalendarIcon } from "../../assets/icons/icons";
import NotificationPanel from "../notifications/NotificationPanel";
import { convertUTCToLocal } from "../../utils/timeUtils";

const DashboardHeader = () => {
  // global
  const navigate = useNavigate();
  const cookies = new Cookies();

  const logoutMutate = useMutation({
    mutationFn: () => logOut(),
    onSuccess: async () => {
      localStorage.clear();
      sessionStorage.clear();
      const allCookies = cookies?.getAll();
      delete allCookies.credentials;
      Object?.keys(allCookies)?.map((i) => {
        cookies?.remove(i);
      });
      navigate("/");
    },
    onError: (error: any) => {
      localStorage.clear();
      sessionStorage.clear();
      const allCookies = cookies?.getAll();
      delete allCookies.credentials;
      Object?.keys(allCookies)?.map((i) => {
        cookies?.remove(i);
      });
      navigate("/");
      notification.error({
        message: error?.response?.data?.detail,
      });
    },
  });

  // dropdown menu items
  const items = [
    {
      key: "1",
      label: "Logout",
      onClick: () => logoutMutate?.mutate(),
    },
  ];

  const currentDate = convertUTCToLocal(new Date(), "DD MMM YYYY, dddd");

  return (
    <div className={Styles.headerContainer}>
      <div className={Styles.insideContainer}>
        <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <img src={AirbusLogo} alt="airbusLogo" height={17} />
            <span style={{ fontWeight: 700, fontSize: "14px", color: "#fff" }}>ALOS</span>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img src={FlowWise} alt="flowWiseLogo" height={30} />
          </div>
        </div>

        <div className={Styles.headerRight}>
          <div className={Styles.dateDisplay}>
            <Icon component={CalendarIcon} />
            <span>{currentDate}</span>
          </div>
          <NotificationPanel />
          <Dropdown menu={{ items }} placement="bottomRight" arrow>
            <Avatar icon={<UserOutlined />} size="large" />
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
